import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.93506 2.50006C1.93506 2.18802 2.18802 1.93506 2.50006 1.93506H3.29295C3.57541 1.93506 3.84629 2.04726 4.04602 2.24699L4.73409 2.93506H12.7615C13.515 2.93506 14.0302 3.69603 13.7504 4.39559L12.1504 8.39559C11.9886 8.79993 11.597 9.06506 11.1615 9.06506H6.73409L5.86409 9.93506H11.5001C11.8121 9.93506 12.0651 10.188 12.0651 10.5001C12.0651 10.8121 11.8121 11.0651 11.5001 11.0651H4.9829C4.30136 11.0651 3.96004 10.241 4.44196 9.75912L5.8371 8.36398L4.01854 3.81757L3.26603 3.06506H2.50006C2.18802 3.06506 1.93506 2.8121 1.93506 2.50006ZM5.33458 4.06506L6.88258 7.93506H11.1175L12.6655 4.06506H5.33458ZM6.89998 13.0001C6.89998 13.4972 6.49703 13.9001 5.99998 13.9001C5.50292 13.9001 5.09998 13.4972 5.09998 13.0001C5.09998 12.503 5.50292 12.1001 5.99998 12.1001C6.49703 12.1001 6.89998 12.503 6.89998 13.0001ZM9.99998 13.9001C10.497 13.9001 10.9 13.4972 10.9 13.0001C10.9 12.503 10.497 12.1001 9.99998 12.1001C9.50292 12.1001 9.09998 12.503 9.09998 13.0001C9.09998 13.4972 9.50292 13.9001 9.99998 13.9001Z"
  />
);

export const ShoppingCartIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="ShoppingCart" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
